import React from "react";
import { useSelector } from "react-redux";
import Spinner from "../../../components/presentationals/Spinner";
import Error from "../../../components/Error/index";
import { RechargeSalesOthersLineChart } from "../../../components/chart/rechargeSalesOthersLineChart";

const OthersLast7DaysView = ({
  partnerRT,
  fetchLast7DaysCsvData,
  handleChange,
  isCsvActive,
  days,
}) => {
  const { getLastSevenTransaction, rechargeSalesCsvLoading } = useSelector(
    (state) => state.rechargeSalesReducer,
  );

  const zeroArray = [0, 0, 0, 0, 0, 0, 0];

  let { data } = getLastSevenTransaction;

  return (
    <>
      {partnerRT === "DT" ? (
        <>
          <div className="col-md-12">
            <div className="roundborder actc">
              <div className="mdnsubtitle">
                <div className="leftdiv">Activation Trend</div>
              </div>
              <div className="mdnchart">
                <RechargeSalesOthersLineChart
                  content={zeroArray}
                  partnerRT={partnerRT}
                />
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          {getLastSevenTransaction.loading ? (
            <Spinner />
          ) : Object.keys(data).length ? (
            <>
              <div className="col-md-12">
                <div className="roundborder actc">
                  <div className="mdnsubtitle">
                    <div className="leftdiv">Recharge Trend</div>
                  </div>
                  {isCsvActive === "Y" ? (
                    <>
                      <div
                        style={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <div className="col-6 col-md-2">
                          <select
                            className="form-control"
                            id="sel1"
                            name="sellist1"
                            onChange={handleChange("unit")}
                          >
                            {days.map((option) => (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-2 col-md-1">
                          {rechargeSalesCsvLoading &&
                          rechargeSalesCsvLoading["LAST"] ? (
                            <Spinner showAlert={false} />
                          ) : (
                            <button
                              type="button"
                              className="btn btn-link btn-sm m-0 p-0"
                              onClick={fetchLast7DaysCsvData}
                            >
                              <img
                                src={
                                  process.env.PUBLIC_URL +
                                  "/assets/images/icons/download-arrow.svg"
                                }
                                alt="download"
                              />
                            </button>
                          )}
                        </div>
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                  <div className="row">
                    <div className="col-md-3">
                      <div className="h-100">
                        <div className="datatable" data-cy="earnings-table">
                          <table className="table table-striped">
                            <thead>
                              <tr>
                                <th scope="col" style={{ fontWeight: "bold" }}>
                                  Day
                                </th>
                                <th
                                  scope="col"
                                  style={{
                                    fontWeight: "bold",
                                    textAlign: "end",
                                  }}
                                >
                                  Count
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {Object.entries(data).map(
                                ([day, value], index) => (
                                  <tr key={index}>
                                    <td>
                                      Day {index + 1}
                                      {index === 0 ? "-Today" : ""}
                                    </td>
                                    <td style={{ textAlign: "end" }}>
                                      {value}
                                    </td>
                                  </tr>
                                ),
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-9">
                      <div className="h-100">
                        <RechargeSalesOthersLineChart content={data} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <Error error={getLastSevenTransaction.error} />
          )}
        </>
      )}
    </>
  );
};

export default OthersLast7DaysView;
